<!-- HERO  -->
<section class="background-white hero hero-home welcome-section" id="home">
  <div class="background-gradient-home" title="NuLifeSpan Rx provides prescription medication discounts for pharmacies nationwide"></div>
  <section class="container">
    <!-- Header  -->
    <section class="header">
      <h2>Save up to 80% on <br /> Prescriptions!</h2>
      <h3 class="d-app-title-home">Download the App</h3>
      <div class="app-link d-app-link" style="justify-content: left;">
        <a href="https://apps.apple.com/us/app/rxhacker/id1450904899" target="_blank"><img class="gap"
            src="assets/images/app_store.svg" /></a>
        <a href="https://play.google.com/store/apps/details?id=com.firebase.rxhacker&hl=en_IN" target="_blank"><img
            src="assets/images/play_store.svg" /></a>
      </div>
      <form>
        <input [(ngModel)]="sendemailval" (keypress)="removemsgerremail($event)" (focus)="removemsgerremail($event)" type="email"
          class="differ shadow download-app-input" name="mno" placeholder="Enter Email Address" autocomplete="off" />
        <div class="button-section">
        <span *ngIf="downloadLoader" class="btn-loader"></span>
        <button (click)="sendemail(sendemailval)" [ngClass]="loaderclass" class="btn secondary d-app-btn">
          Get Download Link
        </button>
        <p [ngClass]="emailsentclass" *ngIf="sendemailStatus">{{ errormsgemail }}</p>
        </div>
      </form>

    </section>
  </section>

</section>
<!-- END  -->
<div class="clearfix"></div>
<!-- Work section -->
<section class="work-section prescribe">
  <div class="columns is-gapless reverse-columns how-it-works is-mobile" id="howItWorks">
    <div class="column">
      <h2>Prescription Savings Anywhere You Go!</h2>
    </div>
    <div class="column hero-image1-shape">
      <!-- Best price  -->
      <div class="columns is-gapless">
        <div class="column">
          <!-- List item 1  -->
          <div class="columns list is-mobile">
            <div class="column list-image is-4 one">
              <!-- List image here ("list-image") -->
              <img src="../../assets/images/saving-icon1.svg" alt="Digital prescription discount coupons at your fingertips, no more paper coupons">
            </div>
            <div class="column">
              <div class="list-item">
                <p class="list-title">No need to keep track of physical coupons</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Discount card  -->
      <div class="columns is-gapless">
        <div class="column">
          <!-- List item 2  -->
          <div class="columns list is-mobile">
            <div class="column list-image is-4 two">
              <img src="../../assets/images/saving-icon2.svg" alt="Check for discounts for multiple prescriptions">
            </div>
            <div class="column">
              <div class="list-item">
                <p class="list-title">Multiple built-in coupons, giving you the best savings on your medication</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Show pharmacist  -->
      <div class="columns is-gapless">
        <div class="column">
          <!-- List item 3  -->
          <div class="columns list is-mobile">
            <div class="column list-image is-4 three">
              <img src="../../assets/images/saving-icon3.svg" alt="Prescription discounts in your location, just provide your zip code">
            </div>
            <div class="column">
              <div class="list-item">
                <p class="list-title">Best prices at your location</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="columns is-gapless">
        <div class="column">
          <!-- List item 3  -->
          <div class="columns list is-mobile">
            <div class="column list-image is-4 three">
              <img src="../../assets/images/saving-icon4.svg" alt="NuLifeSpan Rx prescription discounts are totally free to use!">
            </div>
            <div class="column">
              <div class="list-item">
                <p class="list-title">Discounts are absolutely free!</p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>
<!--  END  -->
<div class="clearfix"></div>
<!-- Work section -->
<section class="work-section best">
  <div class="columns is-gapless is-vcentered reverse-columns how-it-works is-mobile" id="howItWorks">
    <div class="column">
      <!-- Best price  -->
      <div class="columns is-gapless">
        <div class="column">
          <!-- List item 1  -->
          <div class="columns list is-mobile">
            <div class="column list-image is-4 one">
              <!-- List image here ("list-image") -->
              <img src="../../assets/images/money.svg" alt="Search for discounts across 35,000 pharmacies">
            </div>
            <div class="column">
              <div class="list-item">
                <p class="list-title">Search for the best price</p>
                <p class="home-list-subtitle">NuLifeSpan Rx collects prices & discounts from over 60,000 U.S.
                  pharmacies</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Discount card  -->
      <div class="columns is-gapless">
        <div class="column">
          <!-- List item 2  -->
          <div class="columns list is-mobile">
            <div class="column list-image is-4 two">
              <img src="../../assets/images/card.svg" alt="Get your discount card for free for any specific medication">
            </div>
            <div class="column">
              <div class="list-item">
                <p class="list-title">Get your discount card</p>
                <p class="home-list-subtitle">Choose from popular searches or search for your specific medication</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Show pharmacist  -->
      <div class="columns is-gapless">
        <div class="column">
          <!-- List item 3  -->
          <div class="columns list is-mobile">
            <div class="column list-image is-4 three">
              <img src="../../assets/images/phone-icon.svg" alt="Show your pharmacist your card at the pharmacy and receive your discount!">
            </div>
            <div class="column">
              <div class="list-item">
                <p class="list-title">Show pharmacist at time of purchase</p>
                <p class="home-list-subtitle">Simply show the screen on your smart device</p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="column hero-image1-shape change-image">
      <div class="hero-image1" title="Anyone can use their phone or computer to save on new or existing prescriptions!">
      </div>
    </div>
  </div>
</section>
<!--  END  -->
<div class="clearfix"></div>
<!-- Work section -->
<section class="work-section frequent">
  <h2>Frequently Asked Questions</h2>
  <div class="columns is-gapless" id="howItWorks">
    <div class="column">
      <div class="repeat" *ngFor="let faq1 of faqData1">
        <h3 [innerHTML]="faq1.Question"></h3>
        <div [innerHTML]="faq1.Answer"></div>
        <div *ngFor="let subAns of faq1.SubAnswer" [innerHTML]="subAns.A"></div>
      </div>
    </div>
    <div class="column">
      <div class="repeat" *ngFor="let faq2 of faqData2">
        <h3 [innerHTML]="faq2.Question"></h3>
        <div [innerHTML]="faq2.Answer"></div>
        <div *ngFor="let subAns of faq2.SubAnswer" [innerHTML]="subAns.A"></div>
      </div>
    </div>
  </div>
</section>
<!--  END  -->
<div class="clearfix"></div>
<!-- Work section -->
<section class="work-section frequent add-new">
  <div class="columns is-gapless" id="howItWorks">
    <div class="column">
      <h2 class="desktop">How much will I save with my card?</h2>
      <h3>You can save up to 80% per prescription. Most of the time your discount card will save you money over the pharmacy's retail price. If the pharmacy's price is lower than the discount card price or if your insurance co-pay is lower, you pay the lower price.</h3>
      <!--<p>It is always a win-win situation:</p>
      <p>The average savings is $61 per prescription. Most of the time your discount card will save you money. If the pharmacy's price is lower than the discount card price, you pay the lower retail price.</p>-->
    </div>
    <div class="column">
      <h2 class="mobile">How much will I save with my card?</h2>
      <div class="image">
        <img src="../../assets/images/save-card.svg" alt="Save up to 80% on each prescription that you have">
      </div>
    </div>
  </div>
</section>
<!--  END  -->
<div class="clearfix"></div>
<!-- Work section -->
<section class="work-section save">
  <div class="smart-phone">
    <img src="../../assets/images/smartphone.png" alt="NuLifeSpan Rx mobile app provides a convenient way to access your discounts on the go">
  </div>
  <div class="content">
    <h2>Save up to 80% on Prescriptions!</h2>
    <h3>Download the App</h3>
    <div class="form-section">
      <form class="footer-download">
        <input class="form-control differ shadow" [(ngModel)]="sendno" (keypress)="removemsgerr($event)"
          (focus)="removemsgerr($event)" pattern="[789][0-9]{9}" type="text" name="mno" placeholder="Enter Mobile No."
          maxlength="14" autocomplete="off" />
        <span *ngIf="getlinkLoader" class="btn-loader"></span>
        <button [ngClass]="getlinkLoaderclass" class=" btn secondary d-app-btn" (click)="sendmsg(sendno)">
          Get Link
        </button>
      </form>
      <span class="or">Or</span>
      <div class="store">
        <a href="https://apps.apple.com/us/app/rxhacker/id1450904899" target="_blank"><img class="gap"
            src="assets/images/app_store.svg" /></a>
        <a href="https://play.google.com/store/apps/details?id=com.firebase.rxhacker&hl=en_IN" target="_blank"><img
            src="assets/images/play_store.svg" /></a>
      </div>
    </div>
    <p [ngClass]="sendmessageClass">{{sendmessageStatus}}</p>
  </div>
</section>
<!--  END  -->